<template>
    <div class="calculator" v-if="banks.length && !hideCalculator">
        <div class="calc__container">
            <div class="calc__ranges-wrapper">
                <div class="flex calc__desc-wrapper">
                    <img class="calc__ranges-img" :src="thumbnail" alt="">
                    <div>
                        <h2 class="text-left calc__ranges-title">Reiknaðu bílalán hjá Landsbanka</h2>
                        <p class="text-left calc__ranges-description">{{description}}</p>
                    </div>
                </div>
                <div class="flex calc__ranges">
                    <!-- Range Price -->
                    <div class="range-price range">
                        <div class="calc__row-label">
                            <div class="label">Kaupverð</div>
                            <div>
                                <div v-if="!focusPrice" class="value" @click="clickInput('price')">{{parseInt(price).format()}} kr.</div>
                                <div v-else class="value-wrap" data-unit="kr."><input :style="{paddingRight: '38px'}" type="number" ref="price" class="value-input" maxlength="9" v-model="price" @blur="focusPrice = false"></div>
                            </div>
                        </div>
                        <range-slider
                                class="range-width"
                                :min="minPrice"
                                :max="maxPrice"
                                :step="stepPrice"
                                v-model="price">
                        </range-slider>
                    </div>
                    <!-- Range Deposit -->
                    <div class="range-deposit range">
                        <div class="calc__row-label">
                            <div class="label">Innborgun {{parseInt(fundingRatio)}}%</div>
                            <div>
                                <div v-if="!focusDeposit" class="value" @click="clickInput('deposit')">{{parseInt(depositValue).format()}} kr.</div>
                                <div v-else class="value-wrap" data-unit="kr."><input :style="{paddingRight: '38px'}" type="number" ref="deposit" class="value-input" v-model="deposit" @blur="focusDeposit = false"></div>
                            </div>
                        </div>
                        <range-slider
                                class="range-width"
                                :min="20"
                                :max="99"
                                step="1"
                                v-model="fundingRatio">
                        </range-slider>
                    </div>
                    <!-- Range Month -->
                    <div class="range-month range">
                        <div class="calc__row-label">
                            <div class="label">Lánstími</div>
                            <div>
                                <div v-if="!focusMonths" class="value" @click="clickInput('months')">{{months}} mán.</div>
                                <div v-else class="value-wrap" data-unit="mán."><input :style="{paddingRight: '76px'}" type="number" @input="inputMaxValue" ref="months" class="value-input" v-model="months" @blur="focusMonths = false"></div>
                            </div>
                        </div>
                        <range-slider
                                class="range-width"
                                :min="6"
                                :max="maxloanMonths"
                                step="6"
                                v-model="months">
                        </range-slider>
                    </div>
                </div>
                <p v-if="bank.props.info_message" class="text-left calc__ranges-description-2">{{bank.props.info_message}}</p>
            </div>

            <div class="calc__table-wrapper">
                <div class="calc__table-card">
                    <h5 class="calc__table-title">Meðalgreiðsla</h5>
                    <p class="calc__table-value">{{calculateBank.price | monthlyPayment}} <span>/ mán</span></p>
                    <table class="calc__table">
                        <tr class="calc__table-row">
                            <td class="calc__table-col">Heildarlán</td>
                            <td class="calc__table-col">{{fullPrice | monthlyPayment}}</td>
                        </tr>
                        <tr class="calc__table-row">
                            <td class="calc__table-col">Lántökukostnaður
                                <Tooltip>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 3.58173 12.4184 0 8 0C3.58164 0 0 3.58173 0 8C0 12.4184 3.58164 16 8 16C12.4184 16 16 12.4184 16 8Z" fill="#6D9E11"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.10276 5.15708C9.10276 4.6763 8.67683 4.09094 7.95984 4.09094C7.23251 4.09094 6.83774 4.6763 6.83774 5.15708C6.83774 5.65879 7.3053 6.21267 7.95984 6.21267C8.69753 6.21267 9.10276 5.7319 9.10276 5.15708ZM6.54688 11.9091H9.45597V10.5399H8.95724V6.68304H6.54688V8.04185H6.98328V10.5399H6.54688V11.9091Z" fill="#FFFFFE"/>
                                    </svg>
                                    <template #content>
                                        <table>
                                            <tr>
                                                <td>Lántökugjald</td>
                                                <td>{{calculateBank.borrowing | monthlyPayment}}</td>
                                            </tr>
                                            <tr>
                                                <td>Þinglýsing, útl. kostnaður til sýslumanns</td>
                                                <td>{{calculateBank.registrationFee | monthlyPayment}}</td>
                                            </tr>
                                        </table>
                                    </template>
                                </Tooltip>
                            </td>
                            <td class="calc__table-col">{{(+calculateBank.borrowing + +calculateBank.registrationFee) | monthlyPayment}}</td>
                        </tr>
                        <tr class="calc__table-row">
                            <td class="calc__table-col">Vextir</td>
                            <td class="calc__table-col">{{calculateBank.interestRate}}</td>
                        </tr>
                    </table>
                </div>
                <a class="calc__table-btn" target="_blank" :href="`https://www.landsbankinn.is/einstaklingar/lan-og-heimildir/bilalan?marketValue=${oldCarPrice || priceValue}&utm_source=bilaskra.is`">
                    Sækja um bílalán
                </a>
            </div>
        </div>
    </div>
</template>

<script>
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
};
import numeral from 'numeral'
import RangeSlider from 'vue-range-slider'
import {mapActions, mapGetters} from 'vuex'
import Tooltip from "../Tooltip";
export default {
    name: 'Calc',
    components: {
        RangeSlider,
        Tooltip
    },
    filters: {
        monthlyPayment: (value) => {
            const num = numeral(value)
            return !isNaN(value)
                ? `${num.format('0,0[.]00').replace(/,/g, '.')} kr.`
                : '-'
        },
    },
    props: {
        priceValue: {
            type: [String, Number],
            default: 0
        },
        carId: {
            type: [String, Number],
            default: 0
        },
        electroCar: {
            type: Boolean,
            default: false
        },
        hybridCar: {
            type: Boolean,
            default: false
        },
        co2: {
            type: [String, Number],
            default: null
        },
        thumbnail: {
            type: String,
            default: "/img/main-thumb.png"
        },
        oldCarPrice: {
            type: Number,
            default: null
        },
        carYear: {
            type: [String, Number],
            default: 0
        }
    },
    data: () => ({
        price: 0,
        deposit: 0,
        maxloanMonths: 84,
        months: 84,
        registrationFee: 2500,
        paymentFees: 120,

        minPrice: 0,
        maxPrice: 0,
        stepPrice:100000,
        fundingRatio: 50,
        selectedYear: null,
        selectedRowIndex: null,
        focusPrice: false,
        focusDeposit: false,
        focusMonths: false,
        bank: {},
        defaultPrice: true,
        defaultPriceUpdated: false,
        hideCalculator: false,
    }),
    methods: {
        ...mapActions('dealers', {
            fetchBanks: 'FETCH_BANKS'
        }),

        inputMaxValue(e) {
            if (e.target.value > this.maxloanMonths) this.months = this.maxloanMonths
        },
        clickInput(fieldName) {
            const capitalizeFieldName = fieldName.capitalize()
            this[`focus${capitalizeFieldName}`] = true
            setTimeout(() => {
                this.$refs[fieldName].focus()
            }, 0)
        },
        showCalcInfo(index) {
            this.selectedRowIndex === index
                ? this.selectedRowIndex = null
                : this.selectedRowIndex = index
        },
        setPrice() {
            const currentPrice = this.oldCarPrice || this.priceValue
            this.minPrice = currentPrice - (7*this.stepPrice)//this.priceValue * .7
            //this.minPrice = this.priceValue * .7
            this.maxPrice = currentPrice * 1.1
            this.price = currentPrice
        },
        setDeposit() {
            this.deposit = (this.price * this.fundingRatio/100).toFixed()
        },
        convertMonthToYear() {
            this.selectedYear = Math.round(this.months/12)
        },
        checkMobile(data) {
            if(window.innerWidth <= 560) {
                this.showCalcInfo(data)
            }
        },
        initCalculator() {
            const carAge = new Date().getFullYear() - this.carYear
            if (carAge > +this.bank.props.maximum_age_of_the_car) {
                this.$root.$emit('calc-price', null)
                this.hideCalculator = true
                this.defaultPriceUpdated = false
                return
            }
            const m = (this.bank.props.total_maximum_loan_term_and_car_age - carAge) * 12
            this.maxloanMonths = Math.min(m, 84)
            if (this.months !== this.maxloanMonths) this.defaultPriceUpdated = true
            this.months = this.maxloanMonths
        }
    },
    computed: {
        ...mapGetters('dealers', {
            getBanksData: 'GET_BANKS'
        }),
        banks() {
            this.banksRaw = JSON.parse(JSON.stringify(this.getBanksData));
            this.bank = this.banksRaw.find(bank => bank.name.toLowerCase() === 'landsbankinn')

            return this.getBanksData
                ? this.getBanksData
                : []
        },
        description() {
            return this.electroCar ? this.bank.description_electric : this.co2 < 50 ? this.bank.description_co2_less_50 : this.bank.description
        },
        fullPrice() {
            return this.price - this.depositValue + +this.calculateBank.borrowing + +this.calculateBank.registrationFee
        },
        yearIndex() {
            return this.selectedYear-1
        },
        depositValue() {
            return (this.price * this.fundingRatio/100).toFixed()
        },
        fundingRatioIndex() {
            return this.fundingRatio;
            /*
            return this.fundingRatio >= 50
              ? 0 // начиная от 50% и до 100%, годовая процентная ставка не меняется, поэтому после 50% в каждом банке используется первая ставка (первый элемент массива interestRates)
              : 49 - this.fundingRatio.toFixed()
             */
        },
        //Calculations
        loanAmount() {
            return this.price - this.deposit
        },
        calculateBank() {
            const bank = this.bank;
            if (this.electroCar) {
                bank.interestRates = bank.electric_car;
            } else if(this.co2 <= 50){
                bank.interestRates = bank.low_co2;
            }

            const b = bank.borrowing.find(item => item.min_month <= this.months && item.max_month >= this.months).borrowing
            const borrowing =
                this.electroCar && !!bank.electro
                    ? b * (1 - bank.electro / 100)
                    : this.hybridCar && !!bank.plugin_hybrid
                    ? b * (1 - bank.plugin_hybrid / 100)
                    : b

            const costToTakeLoan = (this.loanAmount * borrowing) / 100
            const totalLoan =
                this.loanAmount + costToTakeLoan + this.registrationFee

            // Месячная ставка
            const percentMonthCredit =
                bank.interestRates[this.fundingRatioIndex.toFixed()] / 12 / 100

            // Расчет аннуитетного платежа
            const coefficient =
                (percentMonthCredit *
                    Math.pow(1 + percentMonthCredit, this.months)) /
                (Math.pow(1 + percentMonthCredit, this.months) - 1)

            const resultMonthPayment = coefficient * totalLoan + this.paymentFees

            const interestRate = +bank.interestRates[
                this.fundingRatioIndex.toFixed()
                ]
            const price =
                resultMonthPayment && Number(resultMonthPayment).toFixed()

            if (this.defaultPrice && this.price || this.defaultPriceUpdated) {
                this.$root.$emit('calc-price', price)
                this.defaultPrice = false
                this.defaultPriceUpdated = false
            }

            const borrowingPrice = Math.ceil((this.price - this.depositValue) * +Number(borrowing).toFixed(2) / 100)

            return {
                name: bank.name,
                descr: bank.description,
                logo: bank.logo,
                borrowing: this.electroCar ? borrowingPrice : Math.max(+bank.props.minimum_borrowing_fee, borrowingPrice),
                interestRate: interestRate ? interestRate.toFixed(2) + '%' : '-',
                price,
                value: price,
                discountElectro: this.electroCar && !!bank.electro,
                discountHybrid: this.hybridCar && !!bank.plugin_hybrid,
                registrationFee: bank.props.registration_fee,
            }

        },
    },
    watch: {
        banks: {
            deep: true,
            handler() {
                this.initCalculator()
            }
        },
        priceValue() {
            this.setPrice()
        },
        price() {
            this.setDeposit()
        },
        deposit() {
            if(this.deposit && this.price) {
                this.fundingRatio = this.deposit / this.price * 100
            }
        },
        fundingRatio() {
            this.setDeposit()
        },
        months() {
            this.convertMonthToYear()
        },
        carId() {
            this.fundingRatio = 50
            this.defaultPrice = true
            this.hideCalculator = false
            if (this.oldCarPrice) {
                this.setPrice()
            }
            this.initCalculator()
        }
    },
    mounted() {
        this.setPrice()
        this.setDeposit()
        this.convertMonthToYear()
        this.fetchBanks(this.co2)

        // var input = document.querySelector('.value-input'); // get the input element
        // input.addEventListener('input', resizeInput); // bind the "resizeInput" callback on "input" event
        // resizeInput.call(input); // immediately call the function
        //
        // function resizeInput() {
        //     debugger
        //     this.style.width = this.value.length + "ch";
        // }
    }
}
</script>
